/**
 * The single source of truth for Chesshood web puzzle entitlements.
 * The owner can simulate a FREE plan without losing actual Pro access.
 * Only the puzzle page uses this: other Pro features are unchanged.
 */
export function isUnlimitedPuzzleTraining({
  hasPaidSession = false,
  qaMode = "real",
  actualPro = false,
  monthlyUnlimited = false,
} = {}) {
  if (hasPaidSession) return true;
  if (qaMode === "free") return false;
  if (qaMode === "pro") return true;
  return Boolean(actualPro || monthlyUnlimited);
}

export function nextPuzzleShouldShowPaywall({
  guestMode = false,
  isLastGuestPuzzle = false,
  unlimited = false,
  remainingToday = null,
} = {}) {
  if (guestMode) return Boolean(isLastGuestPuzzle);
  return !unlimited && Number(remainingToday) === 0 && remainingToday !== null;
}
